import { render, staticRenderFns } from "./PortletRenderer.vue?vue&type=template&id=3d09e1d8&"
import script from "./PortletRenderer.vue?vue&type=script&lang=js&"
export * from "./PortletRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../dashboard-carousel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports